import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { FacetPillsComponent } from 'app/my-history/facet/facet-pills/facet-pills.component';
import { CardItemComponent } from 'app/shared/card/card-item/card-item.component';
import { DividerComponent } from 'app/shared/divider/divider.component';
import { IconsComponent } from 'app/shared/icon/icons/icons.component';
import { TooltipComponent } from 'app/shared/tooltip/tooltip.component';
import { ImagesSliderComponent } from 'app/my-history/story/images-slider/images-slider.component';
import { IReactionsResponse, IStoryPayload, ReactionType, StoryUnit } from 'app/my-history/story/story';
import { Facet, FacetAlias, FacetAliasId, FacetAliasNames } from 'app/my-history/facet/facet';
import { provideIcons } from '@ng-icons/core';
import { heroEllipsisHorizontal, heroShare, heroXMark } from '@ng-icons/heroicons/outline';
import { MatMenuModule } from '@angular/material/menu';
import { StoryStatus } from '../story-status';
import { IPreviewUrls } from 'app/shared/form/file.model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VoiceRecordingComponent } from 'app/shared/form/voice-recording/voice-recording.component';
import { StoryService } from '../story.service';

@Component({
  selector: 'app-story-preview',
  standalone: true,
  imports: [
    DividerComponent,
    ImagesSliderComponent,
    FacetPillsComponent,
    IconsComponent,
    CardItemComponent,
    TooltipComponent,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    VoiceRecordingComponent,
  ],
  templateUrl: './story-preview.component.html',
  styleUrl: `./story-preview.component.scss`,
  providers: [provideIcons({ heroXMark, heroShare, heroEllipsisHorizontal })],
})
export class StoryPreviewComponent {
  @Output() shareWithFriendsScreen = new EventEmitter<boolean>();

  story = input.required<IStoryPayload>();
  imageUrls = input<IPreviewUrls[]>([]);
  storyReactions = input<IReactionsResponse | undefined>();
  audioUrl = input<string>();
  date = computed(() => this.storyService.formatDate(this.story()));

  isPreviewMode = input(false);
  close = output();

  onIconClick: OutputEmitterRef<{ type: ReactionType; storyId: string }> = output();

  facetTypes: Signal<Facet[]> = computed(() => {
    let units = []

    if (this.story().units && this.story().units.length) {
      units = [...new Set(this.story().units.map(obj => obj.lenseId))]

      return units.map((lenseId) => ({
        id: lenseId,
        alias: FacetAliasId[lenseId] as FacetAlias,
        name: FacetAliasNames[FacetAliasId[lenseId] as keyof typeof FacetAliasNames],
      }));
    }

    return [];
  })

  storyService = inject(StoryService);

  onClose() {
    this.close.emit();
  }

  shareStoryWith() {
    this.shareWithFriendsScreen.emit(true);
  }

  protected readonly StoryStatus = StoryStatus;
}
